function CloseIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.4001 18.6496L5.3501 17.5996L10.9501 11.9996L5.3501 6.39961L6.4001 5.34961L12.0001 10.9496L17.6001 5.34961L18.6501 6.39961L13.0501 11.9996L18.6501 17.5996L17.6001 18.6496L12.0001 13.0496L6.4001 18.6496Z"
        fill="#707070"
      />
    </svg>
  );
}

export default CloseIcon;
